import type { InjectionKey } from 'vue'

import type { RbacController } from './types/runtime'

export const RBAC_KEY: InjectionKey<RbacController> = Symbol('twinepos-rbac')
